<template>
    <div>
        <button class="btn btn-sm btn-xs btn-outline-primary font-weight-bolder float-right"
                data-toggle="modal" data-target="#add-pandi-checkup"
        >
            <span class="fas fa-plus"></span>
            Add P&I Checkup
        </button>

        <cms-modal2 unique="add-pandi-checkup" title="Add P&I Checkup Report">
            <form @submit.prevent="confirmAddPandiCheckup">

                <div class="form-group form-row mb-1" :class="{ 'has-error': newCheckupReportErrors.checkup_date }">
                    <label for="new-checkup-date" class="col-4 col-form-label font-weight-bold">Date :</label>
                    <div class="col-8">
                        <input type="date" id="new-checkup-date" required
                               class="form-control form-control-sm form-control-xs"
                               v-model="newCheckupReport.checkup_date"
                        >
                        <span class="help-block text-danger" v-if="!!newCheckupReportErrors.checkup_date">
                            <small><strong>{{ newCheckupReportErrors.checkup_date }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1"  :class="{ 'has-error': newCheckupReportErrors.remarks }">
                    <label for="new-checkup-remarks" class="col-4 col-form-label pt-0 font-weight-bold">Remarks :</label>
                    <div class="col-8">
                        <textarea class="form-control form-control-sm" id="new-checkup-remarks" rows="3"
                                  v-model="newCheckupReport.remarks"
                                  style="resize: none"></textarea>
                    </div>
                    <span class="help-block text-danger" v-if="!!newCheckupReportErrors.remarks">
                        <small><strong>{{ newCheckupReportErrors.remarks }} </strong></small>
                    </span>
                </div>

                <div class="form-group form-row mb-2"   :class="{ 'has-error': newCheckupReportErrors.pandiCheckupAttachment }">
                    <label for="new-checkup-attachment" class="col-sm-4 col-form-label pt-0 font-weight-bold">Attachment :</label>
                    <div class="col-sm-8">
                        <div class="custom-file" id="new-checkup-attachment-container">
                            <input type="file" id="new-checkup-attachment"
                                   class="custom-file-input form-control-sm"
                                   accept="application/pdf"
                                   @change="updateFileLabel('new-checkup-attachment')"
                            >
                            <label class="custom-file-label col-form-label-sm text-nowrap" id="new-checkup-attachment-file-label"
                                   for="new-checkup-attachment"
                            >P & I Report Attachment</label>
                        </div>
                        <span class="help-block text-danger" v-if="!!newCheckupReportErrors.pandiCheckupAttachment">
                            <small><strong>{{ newCheckupReportErrors.pandiCheckupAttachment }} </strong></small>
                        </span>
                    </div>
                </div>


                <button type="submit" class="btn btn-warning btn-sm btn-xs font-weight-bold float-right">
                    <i class="fas fa-save"></i>
                    Save Checkup Report
                </button>
            </form>

        </cms-modal2>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { dataMixin } from "@/mixins/dataMixin";
import { gateMixin } from "@/mixins/gateMixin";

import CmsModal2 from "@/components/elements/CmsModal2";

export default {
    name: "AddPandiCheckup",

    mixins: [ vueAppMixin, formMixin, dataMixin, gateMixin ],

    components: { CmsModal2 },

    props: {
        pandi: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            newCheckupReport: {},
            newCheckupReportErrors: {},
        }
    },

    methods: {
        ...mapActions([
            'addPandiCheckup'
        ]),

        async confirmAddPandiCheckup() {
            if(await this.confirmCreateAlert()) {
                let formData = new FormData();
                formData.append('pandi_id', this.pandi.id);
                formData.append('checkup_date', this.newCheckupReport.checkup_date);
                formData.append('remarks', this.newCheckupReport.remarks);
                let fileInput = document.getElementById('new-checkup-attachment');
                let files = fileInput.files;
                if(files.length && files[0]) {
                    formData.append('pandiCheckupAttachment', files[0]);
                }
                let newPandiCheckup = await this.addPandiCheckup(formData);
                if(newPandiCheckup) {
                    if(newPandiCheckup.errors) {
                        this.newCheckupReportErrors = newPandiCheckup.errors;
                    } else {
                        this.newCheckupReport = {};
                        this.newCheckupReportErrors = {};
                        this.successAlert('P&I Checkup Successfully UPLOAD', 'UPLOAD');
                        fileInput.value = null;
                        document.getElementById('close-add-pandi-checkup').click();
                    }
                } else {
                    this.errorAlert('P&I Checkup Failed to UPLOAD', 'UPLOAD');
                }
            }
        }
    }


}
</script>

<style scoped>

</style>